import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom';
import dashboardLogo from '../../Images/logo spoki.jpeg'
import { RiLogoutBoxLine } from "react-icons/ri";
import { message } from 'antd';
import { FaUserTie, FaClinicMedical , FaBriefcaseMedical} from "react-icons/fa"
import { MdDashboard, MdPerson, MdPolicy, MdInfo, MdGavel } from 'react-icons/md';
import { FaQuestion } from "react-icons/fa";
import { BiSupport } from "react-icons/bi";
import { BsImage, BsFileText, BsBook, BsCreditCard, BsChatSquareText } from "react-icons/bs";
import { useNavigate } from 'react-router-dom';
import { IoMdArrowDroprightCircle, IoMdArrowDropdownCircle } from "react-icons/io";

import Loader from '../Loader/Loader'

const Sidenav = ({ isOpen }) => {
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [loading, setLoading] = useState(false)
  const [isFaqDropdownOpen, setIsFaqDropdownOpen] = useState(false)
  const location = useLocation(); // Identifying the current route for the active state

  const navigate = useNavigate();
  const opneLogoutModal = () => {
    setShowLogoutModal(true)
  }

  const handleLogout = async () => {
    setLoading(true);
    try {
      localStorage.clear();
      message.success("Successfully logged out")
      setShowLogoutModal(false)
      setTimeout(() => {
        window.location.href = '/login';

      }, [1000])

    } catch (error) {
      console.log("error in log out", error)
      message.error("something went wrong")
    } finally {
      setLoading(false)
    }
  }


  const toggleFaqDropDown = () => {
    setIsFaqDropdownOpen(!isFaqDropdownOpen)
  }


  return (
    <>

      <aside
        className={`overflow-y-auto bg-gradient-to-br from-gray-700 to-teal-500 text-white scrollbar-hidden w-64 h-screen p-4 fixed top-0 left-0 transition-transform transform ${isOpen ? 'translate-x-0' : '-translate-x-full'
          } shadow-lg`}
      >
        {/* Logo Section */}
        <div className="flex flex-col items-center mb-10">
          <div className="h-48 w-48 bg-white rounded-full flex items-center justify-center shadow-md cursor-pointer" 
          onClick={() => navigate("/home")}
          >
            <img
              className="h-32 w-32"
              src={dashboardLogo}
              alt="Admin Logo"
            />
          </div>
          {/* <h1 className="text-lg font-bold mt-4 text-center">Employee Dating Admin</h1> */}
        </div>

        {/* Navigation Links */}
        <ul className="space-y-6">
          {/* Dashboard Link */}
          <li>
            <Link
              to="/home"
              className={`flex items-center p-2 rounded-md transition-colors ${location.pathname === '/home' ? 'bg-teal-600' : 'hover:bg-teal-700'
                }`}
            >
              <MdDashboard className="text-2xl mr-3" /> {/* Dashboard Icon */}
              <span>Dashboard</span>
            </Link>
          </li>

          {/* Profile Link */}
          {/* <li>
            <Link
              to="/profile"
              className={`flex items-center p-2 rounded-md transition-colors ${location.pathname === '/profile' ? 'bg-teal-600' : 'hover:bg-teal-700'
                }`}
            >
              <MdPerson className="text-2xl mr-3" /> {/* Profile Icon 
              <span>Profile</span>
            </Link>
          </li> */}


          {/* Sub Contractor Link */}
          <li>
            <Link
              to="/admin"
              className={`flex items-center p-2 rounded-md transition-colors ${location.pathname === '/admin' ? 'bg-teal-600' : 'hover:bg-teal-700'
                }`}
            >
              <FaUserTie className="text-xl mr-3" />
              <span>Users</span>
            </Link>
          </li>

          {/* About Us Link */}
         {/* <li>
          <Link
            to="/clinic"
            className={`flex items-center p-2 rounded-md transition-colors ${location.pathname === '/clinic' ? 'bg-teal-600' : 'hover:bg-teal-700'
              }`}
          >
            <FaClinicMedical className="text-xl mr-3" /> 
            <span>Clinics</span>
          </Link>
        </li> */}


         {/* About Us Link */}
         {/* <li>
          <Link
            to="/cases"
            className={`flex items-center p-2 rounded-md transition-colors ${location.pathname === '/cases' ? 'bg-teal-600' : 'hover:bg-teal-700'
              }`}
          >
            <FaBriefcaseMedical className="text-xl mr-3" /> 
            <span>Cases</span>
          </Link>
        </li> */}


         {/* About Us Link */}
         {/* <li>
          <Link
            to="/FAQ/employee"
            className={`flex items-center p-2 rounded-md transition-colors ${location.pathname === '/FAQ/employee' ? 'bg-teal-600' : 'hover:bg-teal-700'
              }`}
          >
            <FaQuestion className="text-xl mr-3" /> 
            <span>FAQ's</span>
          </Link>
        </li> */}

        {/* Banners Management Link */}
        <li>
          <Link
            to="/admin/banners"
            className={`flex items-center p-2 rounded-md transition-colors ${location.pathname === '/admin/banners' ? 'bg-teal-600' : 'hover:bg-teal-700'
              }`}
          >
            <BsImage className="text-xl mr-3" />
            <span>Banners</span>
          </Link>
        </li>

        {/* Content Management Link */}
        <li>
          <Link
            to="/admin/content"
            className={`flex items-center p-2 rounded-md transition-colors ${location.pathname === '/admin/content' ? 'bg-teal-600' : 'hover:bg-teal-700'
              }`}
          >
            <BsFileText className="text-xl mr-3" />
            <span>Content</span>
          </Link>
        </li>

        {/* Stories Management Link */}
        <li>
          <Link
            to="/admin/stories"
            className={`flex items-center p-2 rounded-md transition-colors ${location.pathname === '/admin/stories' ? 'bg-teal-600' : 'hover:bg-teal-700'
              }`}
          >
            <BsBook className="text-xl mr-3" />
            <span>Stories</span>
          </Link>
        </li>

        {/* Subscriptions Management Link */}
        <li>
          <Link
            to="/admin/subscriptions"
            className={`flex items-center p-2 rounded-md transition-colors ${location.pathname === '/admin/subscriptions' ? 'bg-teal-600' : 'hover:bg-teal-700'
              }`}
          >
            <BsCreditCard className="text-xl mr-3" />
            <span>Subscriptions</span>
          </Link>
        </li>

        <li>
          <Link
            to="/admin/feedback"
            className={`flex items-center p-2 rounded-md transition-colors ${location.pathname === '/admin/feedback' ? 'bg-teal-600' : 'hover:bg-teal-700'
              }`}
          >
            <BsChatSquareText className="text-xl mr-3" />
            <span>Feedback Reports</span>
          </Link>
        </li>



        {/* About Us Link */}
        {/* <li>
          <Link
            to="/about-us"
            className={`flex items-center p-2 rounded-md transition-colors ${location.pathname === '/about-us' ? 'bg-teal-600' : 'hover:bg-teal-700'
              }`}
          >
            <MdInfo className="text-xl mr-3" /> {/* About Us Icon */}
            {/* <span>About Us</span>
          </Link>
        </li> */} 

        {/* Terms and Conditions Link */}
        {/* <li>
          <Link
            to="/terms-conditions"
            className={`flex items-center p-2 rounded-md transition-colors ${location.pathname === '/terms-conditions' ? 'bg-teal-600' : 'hover:bg-teal-700'
              }`}
          >
            <MdGavel className="text-xl mr-3" /> 
            <span>Terms & Conditions</span>
          </Link>
        </li> */}

        {/* Privacy Policy Link */}
        {/* <li>
          <Link
            to="/privacy-policy"
            className={`flex items-center p-2 rounded-md transition-colors ${location.pathname === '/privacy-policy' ? 'bg-teal-600' : 'hover:bg-teal-700'
              }`}
          >
            <MdPolicy className="text-xl mr-3" /> 
            <span>Privacy Policy</span>
          </Link>
        </li> */}


        {/* Privacy Policy Link */}
        {/* <li>
          <Link
            to="/help&support"
            className={`flex items-center p-2 rounded-md transition-colors ${location.pathname === '/help&support' ? 'bg-teal-600' : 'hover:bg-teal-700'
              }`}
          >
            <BiSupport className="text-xl mr-3" /> 
            <span>Help & Support</span>
          </Link>
        </li> */}


          {/* Logout Link */}
          <li className=" mt-96" onClick={opneLogoutModal}>
            {loading && <Loader />}
            <div className="flex items-center p-2 rounded-md transition-colors cursor-pointer bg-gradient-to-br from-teal-500 to-gray-700 text-white hover:shadow-lg">
              <RiLogoutBoxLine className="text-xl mr-3" />
              <span>Logout</span>
            </div>
          </li>

        </ul>

        {/* Footer Section */}
        {/* <div className="absolute bottom-4 left-4 text-sm text-gray-300">
          <p>&copy; 2025 Dating Admin</p>
          <p>All rights reserved.</p>
        </div> */}
      </aside>

      {loading && <Loader/>}

      {showLogoutModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
            <h3 className="text-3xl font-bold mb-4 text-start">Confirm logout</h3>
            <p className="mb-4 text-start">Are you sure you want to logout ? </p>
            <div className="flex justify-end gap-4">
              <button onClick={() => { setShowLogoutModal(false) }} className="bg-gray-300 text-black py-3 px-8 rounded-md hover:bg-gray-400 transition duration-200">
                Cancel
              </button>
              <button onClick={handleLogout} className="bg-red-600 text-white py-3 px-8 rounded-md mr-2 hover:bg-red-700 transition duration-200">
                Logout
              </button>
            </div>
          </div>
        </div>
      )
      }

    </>

  )
}

export default Sidenav